const codeLanguages = [
  {
    value: 'en_',
    label: 'ENG'
  },
  {
    value: 'es_',
    label: 'ESP'
  },
  {
    value: 'ca_',
    label: 'CAT'
  },
  {
    value: 'gl_',
    label: 'GL'
  },
  {
    value: 'hi_',
    label: 'HIN'
  },
  {
    value: 'nl_',
    label: 'HOL'
  },
  {
    value: 'id_',
    label: 'IND'
  },
  {
    value: 'lt_',
    label: 'LIT'
  },
  {
    value: 'ml_',
    label: 'MAL'
  },
  {
    value: 'pt_',
    label: 'POR'
  },
  {
    value: 'th_',
    label: 'TAI'
  },
  {
    value: 'fr_',
    label: 'FRA'
  },
  {
    value: 'ja_',
    label: 'JPN'
  },
  {
    value: 'ro_',
    label: 'RUM'
  },
  {
    value: 'ru_',
    label: 'RUS'
  },
  {
    value: 'tr_',
    label: 'TUR'
  },
  {
    value: 'ar_',
    label: 'ARA'
  },
  {
    value: 'zh-TW_',
    label: 'CHT'
  },
  {
    value: 'fi_',
    label: 'FIN'
  },
  {
    value: 'iw_',
    label: 'HEB'
  },
  {
    value: 'lv_',
    label: 'LAV'
  },
  {
    value: 'pl_',
    label: 'POL'
  },
  {
    value: 'sv_',
    label: 'SUE'
  },
  {
    value: 'de_',
    label: 'ALE'
  },
  {
    value: 'bg_',
    label: 'BUL'
  },
  {
    value: 'cs_',
    label: 'CHE'
  },
  {
    value: 'zh_',
    label: 'CHI'
  },
  {
    value: 'el_',
    label: 'GRE'
  },
  {
    value: 'hu_',
    label: 'HUN'
  },
  {
    value: 'da_',
    label: 'DAN'
  },
  {
    value: 'it_',
    label: 'ITA'
  },
  {
    value: 'ko_',
    label: 'KOR'
  },
  {
    value: 'no_',
    label: 'NOR'
  },
  {
    value: 'vi_',
    label: 'VIE'
  }
]

const languages = [
  {
    value: 'af',
    label: 'dashboard_language_afrikaans'
  },
  {
    value: 'sq',
    label: 'dashboard_language_albanian'
  },
  {
    value: 'am',
    label: 'dashboard_language_amharic'
  },
  {
    value: 'ar',
    label: 'dashboard_language_arabic'
  },
  {
    value: 'hy',
    label: 'dashboard_language_armenian'
  },
  {
    value: 'az',
    label: 'dashboard_language_azerbaijani'
  },
  {
    value: 'eu',
    label: 'dashboard_language_basque'
  },
  {
    value: 'be',
    label: 'dashboard_language_belarusian'
  },
  {
    value: 'bn',
    label: 'dashboard_language_bengali'
  },
  {
    value: 'bs',
    label: 'dashboard_language_bosnian'
  },
  {
    value: 'bg',
    label: 'dashboard_language_bulgarian'
  },
  {
    value: 'ca',
    label: 'dashboard_language_catalan'
  },
  {
    value: 'ceb',
    label: 'dashboard_language_cebuano'
  },
  {
    value: 'zh',
    label: 'dashboard_language_chineseSimplified'
  },
  {
    value: 'zh-TW',
    label: 'dashboard_language_chineseTraditional'
  },
  {
    value: 'co',
    label: 'dashboard_language_corsican'
  },
  {
    value: 'hr',
    label: 'dashboard_language_croatian'
  },
  {
    value: 'cs',
    label: 'dashboard_language_czech'
  },
  {
    value: 'da',
    label: 'dashboard_language_danish'
  },
  {
    value: 'nl',
    label: 'dashboard_language_dutch'
  },
  {
    value: 'en',
    label: 'dashboard_language_english'
  },
  {
    value: 'eo',
    label: 'dashboard_language_esperanto'
  },
  {
    value: 'et',
    label: 'dashboard_language_estonian'
  },
  {
    value: 'fi',
    label: 'dashboard_language_finnish'
  },
  {
    value: 'fr',
    label: 'dashboard_language_french'
  },
  {
    value: 'fy',
    label: 'dashboard_language_frisian'
  },
  {
    value: 'gl',
    label: 'dashboard_language_galician'
  },
  {
    value: 'ka',
    label: 'dashboard_language_georgian'
  },
  {
    value: 'de',
    label: 'dashboard_language_german'
  },
  {
    value: 'el',
    label: 'dashboard_language_greek'
  },
  {
    value: 'gu',
    label: 'dashboard_language_gujarati'
  },
  {
    value: 'ht',
    label: 'dashboard_language_haitianCreole'
  },
  {
    value: 'ha',
    label: 'dashboard_language_hausa'
  },
  {
    value: 'haw',
    label: 'dashboard_language_hawaiian'
  },
  {
    value: 'he',
    label: 'dashboard_language_hebrew'
  },
  {
    value: 'hi',
    label: 'dashboard_language_hindi'
  },
  {
    value: 'hmn',
    label: 'dashboard_language_hmong'
  },
  {
    value: 'hu',
    label: 'dashboard_language_hungarian'
  },
  {
    value: 'is',
    label: 'dashboard_language_icelandic'
  },
  {
    value: 'ig',
    label: 'dashboard_language_igbo'
  },
  {
    value: 'id',
    label: 'dashboard_language_indonesian'
  },
  {
    value: 'ga',
    label: 'dashboard_language_irish'
  },
  {
    value: 'it',
    label: 'dashboard_language_italian'
  },
  {
    value: 'ja',
    label: 'dashboard_language_japanese'
  },
  {
    value: 'jv',
    label: 'dashboard_language_javanese'
  },
  {
    value: 'kn',
    label: 'dashboard_language_kannada'
  },
  {
    value: 'kk',
    label: 'dashboard_language_kazakh'
  },
  {
    value: 'km',
    label: 'dashboard_language_khmer'
  },
  {
    value: 'rw',
    label: 'dashboard_language_kinyarwanda'
  },
  {
    value: 'ko',
    label: 'dashboard_language_korean'
  },
  {
    value: 'ku',
    label: 'dashboard_language_kurdish'
  },
  {
    value: 'ky',
    label: 'dashboard_language_kyrgyz'
  },
  {
    value: 'lo',
    label: 'dashboard_language_lao'
  },
  {
    value: 'lv',
    label: 'dashboard_language_latvian'
  },
  {
    value: 'lt',
    label: 'dashboard_language_lithuanian'
  },
  {
    value: 'lb',
    label: 'dashboard_language_luxembourgish'
  },
  {
    value: 'mk',
    label: 'dashboard_language_macedonian'
  },
  {
    value: 'mg',
    label: 'dashboard_language_malagasy'
  },
  {
    value: 'ms',
    label: 'dashboard_language_malay'
  },
  {
    value: 'ml',
    label: 'dashboard_language_malayalam'
  },
  {
    value: 'mt',
    label: 'dashboard_language_maltese'
  },
  {
    value: 'mi',
    label: 'dashboard_language_maori'
  },
  {
    value: 'mr',
    label: 'dashboard_language_marathi'
  },
  {
    value: 'mn',
    label: 'dashboard_language_mongolian'
  },
  {
    value: 'my',
    label: 'dashboard_language_myanmar'
  },
  {
    value: 'ne',
    label: 'dashboard_language_nepali'
  },
  {
    value: 'no',
    label: 'dashboard_language_norwegian'
  },
  {
    value: 'ny',
    label: 'dashboard_language_nyanja'
  },
  {
    value: 'or',
    label: 'dashboard_language_odia'
  },
  {
    value: 'ps',
    label: 'dashboard_language_pashto'
  },
  {
    value: 'fa',
    label: 'dashboard_language_persian'
  },
  {
    value: 'pl',
    label: 'dashboard_language_polish'
  },
  {
    value: 'pt',
    label: 'dashboard_language_portuguese'
  },
  {
    value: 'pa',
    label: 'dashboard_language_punjabi'
  },
  {
    value: 'ro',
    label: 'dashboard_language_romanian'
  },
  {
    value: 'ru',
    label: 'dashboard_language_russian'
  },
  {
    value: 'sm',
    label: 'dashboard_language_samoan'
  },
  {
    value: 'gd',
    label: 'dashboard_language_scotsGaelic'
  },
  {
    value: 'sr',
    label: 'dashboard_language_serbian'
  },
  {
    value: 'st',
    label: 'dashboard_language_sesotho'
  },
  {
    value: 'sn',
    label: 'dashboard_language_shona'
  },
  {
    value: 'sd',
    label: 'dashboard_language_sindhi'
  },
  {
    value: 'si',
    label: 'dashboard_language_sinhala'
  },
  {
    value: 'sk',
    label: 'dashboard_language_slovak'
  },
  {
    value: 'sl',
    label: 'dashboard_language_slovenian'
  },
  {
    value: 'so',
    label: 'dashboard_language_somali'
  },
  {
    value: 'es',
    label: 'dashboard_language_spanish'
  },
  {
    value: 'su',
    label: 'dashboard_language_sundanese'
  },
  {
    value: 'sw',
    label: 'dashboard_language_swahili'
  },
  {
    value: 'sv',
    label: 'dashboard_language_swedish'
  },
  {
    value: 'tl',
    label: 'dashboard_language_tagalog'
  },
  {
    value: 'tg',
    label: 'dashboard_language_tajik'
  },
  {
    value: 'ta',
    label: 'dashboard_language_tamil'
  },
  {
    value: 'tt',
    label: 'dashboard_language_tatar'
  },
  {
    value: 'te',
    label: 'dashboard_language_telugu'
  },
  {
    value: 'th',
    label: 'dashboard_language_thai'
  },
  {
    value: 'tr',
    label: 'dashboard_language_turkish'
  },
  {
    value: 'tk',
    label: 'dashboard_language_turkmen'
  },
  {
    value: 'uk',
    label: 'dashboard_language_ukrainian'
  },
  {
    value: 'ur',
    label: 'dashboard_language_urdu'
  },
  {
    value: 'ug',
    label: 'dashboard_language_uyghur'
  },
  {
    value: 'uz',
    label: 'dashboard_language_uzbek'
  },
  {
    value: 'vi',
    label: 'dashboard_language_vietnamese'
  },
  {
    value: 'cy',
    label: 'dashboard_language_welsh'
  },
  {
    value: 'xh',
    label: 'dashboard_language_xhosa'
  },
  {
    value: 'yi',
    label: 'dashboard_language_yiddish'
  },
  {
    value: 'yo',
    label: 'dashboard_language_yoruba'
  },
  {
    value: 'zu',
    label: 'dashboard_language_zulu'
  }
]

export {
  codeLanguages,
  languages
}
